/** @file GIZMO_AXES: the gizmo's X, Y, Z in pose's z-up world (east, north, up). */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/**
 * The gizmo uses Pose3D's document axes, as the ground lines and the orientation cube do: X = world +x (east, red),
 * Y = world +y (north, green), Z = world +z (up, blue). Index = handle axis 0, 1, 2.
 */
export const GIZMO_AXES: readonly [Vec3, Vec3, Vec3] = [[1, 0, 0], [0, 1, 0], [0, 0, 1]];
